import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class DeleteDocApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/DeleteFile',
      requesterInfo,
    })
  }

  public async deleteDoc(file: string): Promise<any> {
    this.props.url = `${this.props.url}?file=${file}`
    return await this.postAsync<any>()
  }
}
